import { render, staticRenderFns } from "./Starter.vue?vue&type=template&id=15c7110d&"
import script from "./Starter.vue?vue&type=script&lang=js&"
export * from "./Starter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports